import React, { useState } from "react";
import { Form, Dropdown } from "react-bootstrap";
import { VariableSizeList } from "react-window";
import { ICounty } from "../../../../common/types/dasTypes";
import { ICountyDetails } from "../../../../common/types/alertsTypes";

interface IProps {
  countyOptions: ICountyDetails[];
  selectedCountyOptions: ICounty[];
  countyPlaceholder: string;
  handleCountySelect: (selectedItem: ICountyDetails, checked: boolean) => void;
}

const CountySelectionFilter = (props: IProps) => {

  const {
    countyOptions,
    selectedCountyOptions,
    countyPlaceholder,
    handleCountySelect,
  } = props;
  // Todo: Need to create a custom hook to seperate the logic
  const [searchTerm, setSearchTerm] = useState<string>("");

  const filteredCountyOptions: ICountyDetails[] = countyOptions.filter(
    (county) => county.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const Row = ({
    index,
    style,
  }: {
    index: number;
    style: React.CSSProperties;
  }) => {
    const item: ICountyDetails = filteredCountyOptions[index];
    const isChecked: boolean = selectedCountyOptions[0]?.state === item?.state && selectedCountyOptions[0].name === item?.name;
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const isChecked: boolean = event.target.checked;
      handleCountySelect(item, isChecked);
    };
    const handleRowClick = () => {
      const isChecked: boolean = !selectedCountyOptions.includes(item);
      handleCountySelect(item, isChecked);
    };
    return (
      <div style={style} onClick={handleRowClick}>
        <Form.Check
          type="checkbox"
          label={`${item.name} ( ${item.state} )`}
          checked={isChecked}
          onChange={handleChange}
          onClick={(e) => e.stopPropagation()} // Prevent checkbox click event from propagating to the row
        />
      </div>
    );
  };

  return (
    <Dropdown drop="down">
      <Dropdown.Toggle variant="light" id="dropdown-basic">
        {countyPlaceholder}
      </Dropdown.Toggle>
      <Dropdown.Menu style={{ maxHeight: "300px" }}>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search county..."
          style={{ marginBottom: "10px" }}
        />
        <VariableSizeList
          height={200}
          itemCount={filteredCountyOptions.length}
          itemSize={() => 35}
          width={'auto'}
        >
          {Row}
        </VariableSizeList>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CountySelectionFilter;
